var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swag-commerce" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "filters-bar" }, [
        _c("div", { staticClass: "buttons-container" }, [
          _c(
            "button",
            {
              staticClass: "hb-btn secondary",
              class: _vm.totalCurrentFilters > 0 ? "selected" : "",
              on: {
                click: function($event) {
                  return _vm.showFilters()
                }
              }
            },
            [
              _vm.totalCurrentFilters > 0
                ? _c("img", {
                    staticClass: "purple",
                    attrs: {
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                    }
                  })
                : _c("img", {
                    staticClass: "normal",
                    attrs: {
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"
                    }
                  }),
              _vm._v("\n        Filters \n        "),
              _vm.totalCurrentFilters > 0
                ? _c("span", [
                    _vm._v("(" + _vm._s(_vm.totalCurrentFilters) + ")")
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "hb-btn secondary",
              on: {
                click: function($event) {
                  return _vm.showSort()
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/Group_4412.png?v=1722267051"
                }
              }),
              _vm._v("Sort")
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "products-container" }, [
        _c("div", { staticClass: "products-list" }, [
          _vm.sortedProducts && _vm.sortedProducts.length > 0
            ? _c(
                "ul",
                { staticClass: "no-scrollbar" },
                _vm._l(_vm.sortedProducts, function(product) {
                  return _c("li", [
                    _c(
                      "div",
                      {
                        staticClass: "product-container",
                        on: {
                          click: function($event) {
                            return _vm.selectProduct(product)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "product-image-container" }, [
                          _c("img", {
                            staticClass: "logo-placeholder",
                            attrs: {
                              src:
                                "https://cdn.shopify.com/s/files/1/1363/8433/files/logo_grey_2.svg?v=1725379927",
                              alt: "logo here"
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "lazyload main-image",
                            attrs: {
                              width: "280",
                              height: "280",
                              src: _vm._f("getProductImage")(product)
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "secondary-badge" }, [
                            _vm._v(_vm._s(_vm.secondaryBadge(product)))
                          ]),
                          _vm._v(" "),
                          _vm._m(2, true)
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "hb-btn secondary",
                            on: {
                              click: function($event) {
                                return _vm.selectProduct(product)
                              }
                            }
                          },
                          [_vm._v("Customize Now")]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "title" }, [
                          _vm._v(_vm._s(product.title))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "product-price-container" }, [
                          product.variants.find(function(x) {
                            return x.price != ""
                          }).compare_at_price
                            ? _c("span", { staticClass: "discount-price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moneySaleFormat")(
                                      product.variants.find(function(x) {
                                        return x.price != ""
                                      }).compare_at_price
                                    )
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "price" }, [
                            _vm._v(_vm._s(_vm._f("moneyFormat")(product)))
                          ])
                        ])
                      ]
                    )
                  ])
                }),
                0
              )
            : _c(
                "ul",
                { staticClass: "no-scrollbar" },
                _vm._l(12, function(n) {
                  return _c("li", { key: n }, [_c("AddonProductSkeleton")], 1)
                }),
                0
              )
        ])
      ]),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-section" }, [_c("FAQ")], 1),
      _vm._v(" "),
      _vm.filterIsShown
        ? _c("FiltersMobile", {
            attrs: {
              filteredPreAddons: _vm.filteredPreProducts,
              filteredAddons: _vm.sortedProducts
            },
            on: {
              closefilter: function($event) {
                return _vm.showFilters()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sortIsShown
        ? _c("SortMobile", {
            on: {
              closefilter: function($event) {
                return _vm.showSort()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedProduct
        ? _c("BrandableModal", {
            attrs: { selectedAddon: _vm.selectedProduct },
            on: {
              close: function($event) {
                return _vm.selectProduct(null)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-container" }, [
      _c("picture", { staticClass: "header-picture" }, [
        _c("source", {
          attrs: {
            media: "(max-width: 767px)",
            srcset:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/mobile_swag_header.jpg?v=1725919435"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "main-image",
          attrs: {
            src:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/header_ecommerce.png?v=1725037354"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title-container" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Shop Swag")]),
        _vm._v(" "),
        _c("div", { staticClass: "instructions" }, [
          _c("div", [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/trending_swag.svg?v=1725037476"
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("Trending "), _c("br"), _vm._v(" Swag")])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/quality_icon_77d7aa1e-b76d-4d1a-bf41-e87458c8cf41.svg?v=1725037476"
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "desktop" }, [
              _vm._v("Quality "),
              _c("br"),
              _vm._v(" brand names")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mobile" }, [_vm._v("Quality brands")])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/ship_many_icon_a6aa3cc2-bf00-4ffb-895a-db7c8e8450f1.svg?v=1725037476"
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "desktop" }, [
              _vm._v("Ship one or many "),
              _c("br"),
              _vm._v(" with ease")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mobile" }, [_vm._v("Bulk shipping")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-header" }, [
      _c("div", { staticClass: "top-brands" }, [
        _c("p", { staticClass: "title" }, [
          _vm._v("Top Brands, "),
          _c("br", { staticClass: "mobile" }),
          _vm._v(" Your Style, Your Logo")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle desktop" }, [
          _vm._v(
            "Shop swag from your favorite brands and discover trending new brands today. Don’t see what you want? "
          ),
          _c(
            "a",
            {
              attrs: { href: "https://calendar.app.google/BS3epNk6LrNPc7ca6" }
            },
            [_vm._v("Talk to Sales.")]
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle mobile" }, [
          _vm._v("Don’t see what you want? "),
          _c(
            "a",
            {
              attrs: { href: "https://calendar.app.google/BS3epNk6LrNPc7ca6" }
            },
            [_vm._v("Talk to Sales.")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "edit-float" }, [
      _c("p", [_vm._v("Add your logo")]),
      _vm._v(" "),
      _c("div", { staticClass: "edit-btn" }, [
        _c("img", {
          attrs: {
            src:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634",
            alt: "edit"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swag-solutions" }, [
      _c("img", {
        staticClass: "background-image",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/gradient_bg.png?v=1725031842"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "floating-container" }, [
        _c("div", { staticClass: "details" }, [
          _c("h2", { staticClass: "desktop" }, [
            _vm._v("Unparalleled Swag Solutions")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Need more support with your swag? We can help:")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _c("img", {
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114",
                  alt: "Check"
                }
              }),
              _vm._v("Storage & distribution")
            ]),
            _vm._v(" "),
            _c("li", [
              _c("img", {
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114",
                  alt: "Check"
                }
              }),
              _vm._v("Let them pick their swag")
            ]),
            _vm._v(" "),
            _c("li", [
              _c("img", {
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114",
                  alt: "Check"
                }
              }),
              _vm._v("Sizing & logistics handled")
            ]),
            _vm._v(" "),
            _c("li", [
              _c("img", {
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114",
                  alt: "Check"
                }
              }),
              _vm._v("Custom swag kits")
            ]),
            _vm._v(" "),
            _c("li", [
              _c("img", {
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114",
                  alt: "Check"
                }
              }),
              _vm._v("Logo boxes")
            ])
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "hb-btn primary",
              attrs: { href: "https://calendar.app.google/BS3epNk6LrNPc7ca6" }
            },
            [_vm._v("Book a Call")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "image-container" }, [
          _c("img", {
            staticClass: "lazyload main-image",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/webfx.png?v=1724947313",
              alt: "swag"
            }
          })
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "mobile" }, [
          _vm._v("Unparalleled Swag Solutions")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }